module.exports = __webpack_public_path__ + "img/undecided.8d2cd253.svg";